import React from "react";
import { Typography } from "@mui/material";
import Timeline from '@mui/lab/Timeline';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import { styled } from '@mui/material/styles';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';

// Styled components with CSS-in-JS
const CustomTimelineDot = styled(TimelineDot)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  margin: 0, // Equivalent to .css-5hims0-MuiTimelineDot-root
}));

const CustomTimelineConnector = styled(TimelineConnector)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  height: 3,
}));

const CustomTimelineContent = styled(TimelineContent)({
  marginTop: '-11px', // Equivalent to .css-mc0a86-MuiTypography-root-MuiTimelineContent-root
});

const ApplicationTimeline = ({ approvelist, formatDate }) => (
  <>
    <Typography
      variant="h6"
      component="div"
      gutterBottom
      sx={{ marginLeft: "12px", marginTop: "2px" }}
    >
      <b>Application Timeline</b>
    </Typography>
    <Timeline
      sx={{ [`& .${timelineItemClasses.root}:before`]: { flex: 0, padding: 0 } }}
    >
      <TimelineItem>
        <TimelineSeparator>
          <CustomTimelineDot className="MuiTimelineDot-success" />
          <CustomTimelineConnector />
        </TimelineSeparator>
        <CustomTimelineContent>
          <Typography variant="body1">
            <b>Submitted on</b> : {formatDate(approvelist.appliedDate) || '-'}
          </Typography>
        </CustomTimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <CustomTimelineDot className="MuiTimelineDot-success" />
        </TimelineSeparator>
        <CustomTimelineContent>
          <Typography variant="body1">
            <b>Requested to</b> : {approvelist.approverName || '-'}
          </Typography>
        </CustomTimelineContent>
      </TimelineItem>
    </Timeline>
  </>
);

export default ApplicationTimeline;
